export function inputImage(inputImageEl, inputDelEl, inputUplinkEl) {
  if ($(inputImageEl).length) {
    $(function () {

      // 添付画像の表示する
      $('form').on('change', 'input[type="file"]', function (e) {
        var file = e.target.files[0];
        var reader = new FileReader();
        // var img_form = $(e.target).closest(inputImageEl);
        var img_form = $(e.target).parent().parent().prev();
        var label = img_form.find(inputUplinkEl);
        var del = img_form.find(inputDelEl);
        var pic = img_form.find('.up_file');
        pic = $('<img src="" alt="" class="up_file">');
        label.before(pic);

        reader.onload = function (e) {
          pic.attr('src', e.target.result);
          pic.css('display', 'block');
          label.css('display', 'none');
          del.css('display', 'block');
        };
        reader.readAsDataURL(file);
      });

      // 写真削除
      $(document).on('click', inputDelEl, function (e) {
        var wpcf7 = $(e.target).closest('.wpcf7');
        var img_form = $(e.target).closest(inputImageEl);
        img_form.find('.up_file').remove();
        img_form.find(inputUplinkEl).css('display', 'block');
        img_form.find('input').val('');
        img_form.find(inputDelEl).css('display', 'none');
        img_form.replaceWith(img_form.clone(true));
      });
      $('.up_file').css('display', 'none');
      $(inputDelEl).css('display', 'none');
    });

  }
}
